export default (error) => {
    const statusCode = error?.response?.status;
    const message = error?.response?.data?.message;

    return {statusCode, message};
}
